import React, { Component } from "react";
import styled from "styled-components";
import { Spinner } from "@blueprintjs/core";

import { withFirebase } from "../components/Firebase";
import Editor from "../components/Editor";
import ScriptViewer from "../components/ScriptViewer";

const Center = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
`;

interface Props {
  firebase: any;
}

class Live extends Component<Props> {
  state = {
    document: null
  };

  componentDidMount() {
    // Get data from Firestore.
    this.props.firebase.db
      .collection("panels")
      .doc("1")
      .onSnapshot(doc => {
        this.setState({ document: doc.data() });
      });
  }

  handleSave = data => {
    this.props.firebase.db
      .collection("panels")
      .doc("1")
      .update({
        data
      });
  };

  handleSwitchArt = () => {
    this.props.firebase.db
      .collection("panels")
      .doc("1")
      .update({
        type: "art"
      });
  };

  render() {
    if (this.state.document !== null) {
      if (this.state.document.type === "art") {
        return (
          <Editor
            document={this.state.document}
            handleSave={this.handleSave}
            live
          />
        );
      } else if (this.state.document.type === "script") {
        return <ScriptViewer document={this.state.document} switchArt={this.handleSwitchArt} />;
      }
    }
    return (
      <Center>
        <Spinner />
      </Center>
    );
  }
}

export default withFirebase(Live);
